const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '超清蓝光画质',
    desc: '全平台支持4K超清蓝光分辨率，HDR色彩增强技术带来影院级视觉享受，每一帧都细腻逼真。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '不缓冲秒播放',
    desc: '多线路CDN智能加速，自适应码率技术确保流畅播放体验，高峰时段也能秒开秒播。',
    color: 'accent',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量影视资源',
    desc: '10万+部电视剧、电影、综艺、动漫内容持续更新，覆盖国内外热门题材与类型，应有尽有。',
    color: 'secondary',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步观看',
    desc: '手机、平板、电脑与大屏TV全端覆盖，播放进度自动同步，随时随地继续观看精彩内容。',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费安全无广告',
    desc: '完全免费无需付费订阅，无弹窗广告干扰，平台采用HTTPS加密传输，安全可靠放心观看。',
    color: 'accent',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            为什么选择天美麻花星空影视免费在线观看
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature, idx) => {
            const iconBg =
              feature.color === 'primary'
                ? 'bg-primary-500/15 text-primary-400'
                : feature.color === 'accent'
                  ? 'bg-accent-500/15 text-accent-400'
                  : 'bg-secondary-500/15 text-secondary-400';
            return (
              <div
                key={idx}
                className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-300/15 text-center group hover:border-background-300/30 transition-all"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconBg} mx-auto mb-4 transition-transform duration-200 group-hover:scale-110`}>
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}